<template>
    <b-list-group-item
        @click="$emit('click', $event)"
        v-bind="{ ...$props, variant: color }"
    >
        <slot />
    </b-list-group-item>
</template>

<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
    components: { BListGroupItem },
    props: {
        href: { type: String },
        color: { type: String, default: 'none' },
    },
}
</script>